export default "/images/231ef1e0c5f6ae743ff54971c8f6952b.avif";